import React from 'react';
import SubfolderSlider from '../SubfolderSlider';
import { compose } from 'redux';
import withCurrentGallectionSubfolders from '../../_hocs/withCurrentGallectionSubfolders';
import withCurrentSubfolder from '../../_hocs/withCurrentSubfolder';
import FolderCard from '../../../FolderCard';
const enhance = compose(withCurrentGallectionSubfolders, withCurrentSubfolder);
export const SelectableSubfolderSlider = ({ subfolders, currentSubfolderId, setCurrentSubfolderId })=>{
    if (!subfolders.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(SubfolderSlider, null, subfolders.map((subfolder, index)=>/*#__PURE__*/ React.createElement(FolderCard, {
            width: 128,
            isSelected: subfolder.folderId === currentSubfolderId,
            onClick: ()=>setCurrentSubfolderId(subfolder.folderId),
            withLink: false,
            key: subfolder.folderId,
            folder: subfolder
        })));
};
SelectableSubfolderSlider.displayName = 'SubfolderSliderSelector';
export default enhance(SelectableSubfolderSlider);
